export default "__VITE_ASSET__BW6fJIfC__"